import { useState } from "react";
import Footer from "../Components/Footer";
import Header from "./Header";
import LoginForm from "./LoginForm";

export default function LoginPage(props) {
    return (
      <div>
        <Header/>
        <LoginForm />
        <Footer />
      </div>
    );
  }